export const INQUIRYFORM_QUESTION_TYPE: Record<string, string> = {
  NAME: 'NAME',
  EMAIL: 'EMAIL',
  INQUIRY_TYPE: 'TYPE',
  MAINTEXT: 'MAINTEXT',
  TEXTBOX: 'TEXTBOX',
  TEXTBOX_LONG: 'TEXTBOX_LONG',
  NUMBER: 'NUMBER',
  PHONE_NUMBER: 'PHONE_NUMBER',
  DATE: 'DATE',
  TIME: 'TIME',
  CHECKBOX: 'CHECKBOX',
  OUTLET_SELECT: 'OUTLET_SELECT',
  SINGLE_SELECT: 'SINGLE_SELECT',
  FILE_UPLOAD: 'FILE_UPLOAD',
  TEXT: 'TEXT',
};

export const INQUIRYFORM_THEME: Record<string, string> = {
  headerBgColor: '#D65544',
  headerTextColor: '#FFFFFF',
  titleFontType: 'Gilroy-Regular',
  backgroundColor: '#D65544',
  fontColor: '#FFFFFF',
  fontType: 'Gilroy-Regular',
  highlightColor: '#FEFEFE',
};
